module.exports = __webpack_public_path__ + "static/media/5.2ae8fc15.jpg";